export enum Estado {
  EN_PROCESO = 1,
  DEVOLUCION = 2,
  DEVOLUCION_SUBSANADA = 3,
  RECHAZADO = 4,
  APROBADO_PARCIAL = 5,
  APROBADO = 6,
  COMPLETADO_PARCIAL = 7,
  COMPLETADO = 8,
  EN_VALIDACION_INTERNA = 9,
  COMPLETADO_MANUAL = 10
}
